import s from "./ConnectMethod.module.css";

import right from "@assets/images/arrow-right.svg";

const ConnectMethod = ({title, redirect, imgSrc, imgStyle}) => {
  return (
    <button onClick={redirect} className={s.connestBtn}>
      <div className={s[imgStyle]}>
        <img src={imgSrc} alt="" />
      </div>
      {title}
      <div className={s.imgArrow} >
        <img src={right} alt="" />
      </div>
    </button>
  );
};

export default ConnectMethod;
